(function (app, ng) {
    app.provider("surveyRenewalDialog", [function () {
        this.$get = ["$mdDialog", "$q", "eligibilityFormApi", "_", function ($mdDialog, $q, eligibilityFormApi, _) {
            return {
                open: function (event, surveyRenewals, filterBySurveyId) {
                    var promises = [];
                    var returnObj = {};

                    //promises.push(eligibilityFormApi.getSurveyRenewals().then(function (response) {
                    //    returnObj.surveyRenewals = response;
                                             
                    //}));
                 
                    return $q.all(promises).then(function () {
                        return $mdDialog.show({
                            bindToController: true,
                            controllerAs: "$ctrl",
                            controller: "renewalDialogCtrl",
                            templateUrl: "App/Enrollment/Renewals/renewals.html",
                            parent: ng.element(document.body),
                            targetEvent: event,
                            clickOutsideToClose: false,
                            locals: {
                                surveyRenewals: surveyRenewals,
                                filterBySurveyId: filterBySurveyId
                            }
                        }).then(function (response) {                            
                            return returnObj;
                        });
                    });
                }
            };
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line